import React from 'react';
import ListItemBase from './ListItemBase';
import { useThemeTokens } from '../ThemeProvider';
import { variantProp } from '../utils';

/**
 * ListItem is responsible for rendering icon or a bullet as side item
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ListItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    tokens,
    variant,
    children,
    title,
    ...listItemProps
  } = _ref;
  const themeTokens = useThemeTokens('List', tokens, variant);
  return /*#__PURE__*/_jsx(ListItemBase, {
    tokens: themeTokens,
    ref: ref,
    ...listItemProps,
    title: title,
    children: children
  });
});
ListItem.displayName = 'ListItem';
ListItem.propTypes = {
  variant: variantProp.propType,
  ...ListItemBase.propTypes
};
export default ListItem;